import { render, staticRenderFns } from "./stock.vue?vue&type=template&id=0cee243a&scoped=true"
import script from "./stock.vue?vue&type=script&lang=ts"
export * from "./stock.vue?vue&type=script&lang=ts"
import style0 from "./stock.vue?vue&type=style&index=0&id=0cee243a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cee243a",
  null
  
)

export default component.exports